(function($) {
	'use strict';
	$.fn.Collection__Duplicate = function() {
		this.each(function() {

			/*
			 * Action: Duplicate Collection
			 */
			var $self = $(this);
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();

				// Get options
				var overlay = $('#collection--save-to-my-collections').html(),
					collection_title = $self.closest('.header-holder').find('h4.collection-title').length > 0 ? $self.closest('.header-holder').find('h4.collection-title').first().text() : $('h4.collection-title').first().text(); // <= collection-title auto populated from h4.collection-title

				// Parse it
				Mustache.parse( overlay );
				var output = Mustache.render( overlay, { 'temp_title' : Front.translations.my + ' ' + collection_title } );

				// Close other overlays
				var timeout = 10;
				if( $('#overlay-white').length > 0 ) {

					// Make sure we wait for it to be closed
					timeout = $.Globals.fxSpeed;

					// Close the overlay
					$.Globals.closeOverlay();

				}

				setTimeout( function() {

					// Add it to dom and fade it in
					$.Body.append( output );

					// Async
					setTimeout( function() {

						// Fade it in
						$.Body.addClass('overlay-white-on');

						// Save new $overlay
						var $overlay = $('#overlay-white');

						// Highlight input text
						$overlay.find('#new-title').select();

						// Listen for form submit
						$overlay.find('form').off('submit.duplicate-collection').on('submit.duplicate-collection', function(e) {
							e.preventDefault();

							// Sets listeners on $self
							$.Globals.overlayNotify( $self, Front.translations.saving, Front.translations.collection_saved );

							// Create new collection at the DB
							var vars = {
								'cid'		: $self.data('cid'),
								'ctype'		: $self.data('ctype'),
								'ctitle'	: $overlay.find('input[type="text"]').val(),
							};

							// console.log($overlay.find('input[type="text"]').val());
							$.Globals.ajax( 'collection__duplicate', vars, function( data ) {

								// Also receives data.new_collection_url
								if( data.success ) {

									// Track in Google
									$.Globals.track_event( 'Collection Duplicated' );


									// Listen for complete to close overlay then trigger success message
									$self.off('overlay-notify-complete').on('overlay-notify-complete', function() {

										$.Globals.closeOverlay();

									}).trigger('overlay-notify-success');

								}
							});

						});

						// Add global close overlay listener
						$.Globals.listenForGlobalCloseOverlay();

					}, 10 );


				}, timeout );

			});


		});
		return this;
	};
}(jQuery));
